var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdDocumentLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20.2222,
    height: 20.2222,
    viewBox: "0 0 20.2222 20.2222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_all"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.94444 0.73148C4.27404 0.73148 3.63109 0.997799 3.15703 1.47185C2.68298 1.9459 2.41667 2.58885 2.41667 3.25926V16.7407C2.41667 17.4112 2.68298 18.0541 3.15703 18.5282C3.63108 19.0022 4.27403 19.2685 4.94444 19.2685H15.0556C15.726 19.2685 16.3689 19.0022 16.843 18.5282C17.317 18.0541 17.5833 17.4112 17.5833 16.7407V7.47222C17.5833 7.47222 17.5833 7.47221 17.5833 7.47221C17.5833 7.23816 17.4879 7.0264 17.3338 6.87371L11.4943 1.03415C11.4737 1.0109 11.4518 0.989127 11.4288 0.968828C11.2718 0.816721 11.0616 0.73148 10.8426 0.73148H4.94444ZM10 2.41667H4.94444C4.72097 2.41667 4.50666 2.50544 4.34864 2.66346C4.19062 2.82147 4.10185 3.03579 4.10185 3.25926V16.7407C4.10185 16.9642 4.19062 17.1785 4.34864 17.3365C4.50666 17.4946 4.72097 17.5833 4.94444 17.5833H15.0556C15.279 17.5833 15.4933 17.4946 15.6514 17.3365C15.8094 17.1785 15.8981 16.9642 15.8981 16.7407V8.3148H10.8426C10.3772 8.3148 10 7.93756 10 7.47221V2.41667ZM14.7065 6.62962L11.6852 3.60827V6.62962H14.7065Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1F2129"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdDocumentLg);
export default __webpack_public_path__ + "static/media/id-document-lg.0d799ea7dcc14bcdffdcac2a08705956.svg";
export { ForwardRef as ReactComponent };